<template>
	<div>
		<v-card
				class="mx-auto"
				max-width="500"
				eeeeelevation="6"
				v-if="pedido && pedido.opción"
				:disabled="desactivado || aModificar || aCancelar || pedido.estado === 'CANCELADO' || pedido.estado === 'ANULADO'"
				:elevation="elevation || elevation === 0 ? elevation : 6"
			>

				<opcion-resumen :opción="pedido ? pedido.opción : null"></opcion-resumen>

				<v-divider></v-divider>

				<v-card-text>

					<p v-if="pedido.ubicación"><strong>Ubicación:</strong> {{ pedido.ubicación.nombre }}</p>

					<p v-if="pedido.notas"><strong>Notas:</strong> {{ pedido.notas }}</p>

				</v-card-text>

				<v-divider></v-divider>

				<v-card-text>

					<v-chip class="ma-2" color="deep-orange" text-color="white" v-if="pedido.estado === 'NO_ORDENADO'">
						<v-avatar left>
							<v-icon>mdi-alert-circle</v-icon>
						</v-avatar>
						No ordenado
						<v-icon right size="medium" class="ml-3" title="Modificar algo" @click="modificarNoOrdenado">
							edit
						</v-icon>
						<v-icon right size="medium" class="ml-3 mr-1" title="Cancelar orden" @click="confirmarCancelarPedidoNoOrdenado = !confirmarCancelarPedidoNoOrdenado">
							delete
						</v-icon>
					</v-chip>

					<v-chip class="ma-2" color="amber" text-color="white" v-if="pedido.estado === 'ORDENANDO'" :close="permitirCancelarPedidoPendiente" @click:close="cancelarPedidoPendiente">
						<v-avatar left>
							<v-icon>mdi-upload</v-icon>
						</v-avatar>
						Ordenado
					</v-chip>

					<v-chip class="ma-2" color="cyan darken-1" text-color="white" v-if="pedido.estado === 'ORDENADO'"
						_UUclick_close="close"
					>
						<v-avatar left>
							<v-icon>mdi-clipboard-list</v-icon>
						</v-avatar>
						Ordenado
						<v-btn icon right title="Modificar algo" class="ml-2" @click="modificarOrdenado" :loading="aModificar" :disabled="aModificar" v-if="pedido.temporizadorModificar > 0">
							<v-icon color="white" size="medium">edit</v-icon>
						</v-btn>
						<v-btn icon right title="Cancelar orden" @click="confirmarCancelarPedidoOrdenado = !confirmarCancelarPedidoOrdenado" :loading="aCancelar" :disabled="aCancelar" v-if="pedido.temporizadorCancelar > 0">
						<v-icon color="white" size="medium">delete</v-icon>
						</v-btn>
					</v-chip>

					<v-chip class="ma-2" color="teal" text-color="white" v-if="pedido.estado === 'PREPARANDO'">
						<v-avatar left>
							<v-icon>mdi-chef-hat</v-icon>
						</v-avatar>
						Está siendo preparado
					</v-chip>

					<v-chip class="ma-2" color="light-green darken-3" text-color="white" v-if="pedido.estado === 'EN_CAMINO'">
						<v-avatar left>
							<v-icon>mdi-walk</v-icon>
						</v-avatar>
						Viene en camino
					</v-chip>

					<v-chip class="ma-2" color="green darken-2" text-color="white" v-if="pedido.estado === 'SERVIDO'">
						<v-avatar left>
							<v-icon>mdi-check-circle</v-icon>
						</v-avatar>
						Servido
					</v-chip>

					<v-chip class="ma-2" color="green darken-4" text-color="white" v-if="pedido.estado === 'PAGADO'">
						<v-avatar left>
							<v-icon>mdi-check-all</v-icon>
						</v-avatar>
						Finalizado
					</v-chip>

					<v-chip class="ma-2" color="grey" text-color="white" v-if="pedido.estado === 'CANCELADO'">
						<v-avatar left>
							<v-icon>mdi-cancel</v-icon>
						</v-avatar>
						Cancelado
					</v-chip>

					<v-chip class="ma-2" color="grey" text-color="white" v-if="pedido.estado === 'ANULADO'">
						<v-avatar left>
							<v-icon>mdi-null</v-icon>
						</v-avatar>
						Anulado
					</v-chip>


					<!-- El siguiente es redundante, pero lo dejo para que sea más visible -->
					<v-btn
						small
						tile
						block
						class="mb-2 white--text"
						color="blue-grey"
						@click="modificarNoOrdenado"
						v-if="pedido.estado === 'NO_ORDENADO'"
					>
						Modificar algo
					</v-btn>

					<v-btn
						small
						tile
						block
						class="mb-2 white--text"
						color="indigo"
						@click="ordenar"
						v-if="pedido.estado === 'NO_ORDENADO'"
					>
						Ordenar
					</v-btn>

					<!-- El siguiente es redundante, pero lo dejo para que sea más visible -->
					<v-btn
						small
						tile
						block
						class="mb-2"
						color="error"
						@click="confirmarCancelarPedidoNoOrdenado = !confirmarCancelarPedidoNoOrdenado"
						v-if="pedido.estado === 'NO_ORDENADO'"
					>
						Cancelar orden
					</v-btn>

					<v-alert tile dense type="error" border="left" v-if="pedido.estado === 'NO_ORDENADO' && confirmarCancelarPedidoNoOrdenado">
						<p class="mb-0">¿Confirma que quiere cancelar este pedido? </p>
						<v-btn x-small tile color="blue-grey" class="white--text" @click="cancelarPedidoNoOrdenado">Sí, cancelarlo</v-btn>
					</v-alert>

					<!-- El siguiente es redundante, pero lo dejo para que sea más visible -->
					<v-btn
						small
						tile
						block
						class="mb-2 white--text"
						color="blue-grey"
						@click="modificarOrdenado"
						:loading="aModificar"
						:disabled="aModificar"
						v-if="pedido.estado === 'ORDENADO' && pedido.temporizadorModificar > 0"
					>
						Modificar algo <span v-if="pedido.temporizadorModificar < 100">&nbsp;[{{ pedido.temporizadorModificar }}]</span>
					</v-btn>

					<!-- El siguiente es redundante, pero lo dejo para que sea más visible -->
					<v-btn
						small
						tile
						block
						class="mb-2"
						color="error"
						@click="confirmarCancelarPedidoOrdenado = !confirmarCancelarPedidoOrdenado"
						:loading="aCancelar"
						:disabled="aCancelar"
						v-if="pedido.estado === 'ORDENADO' && pedido.temporizadorCancelar > 0"
					>
						Cancelar orden <span v-if="pedido.temporizadorCancelar < 100">&nbsp;[{{ pedido.temporizadorCancelar }}]</span>
					</v-btn>

					<v-alert tile dense type="error" border="left" v-if="pedido.estado === 'ORDENADO' && confirmarCancelarPedidoOrdenado">
						<p class="mb-0">¿Confirma que quiere cancelar este pedido? </p>
						<v-btn x-small tile color="blue-grey" class="white--text" @click="cancelarPedidoOrdenado">Sí, cancelarlo</v-btn>

					</v-alert>

				</v-card-text>

			</v-card>

			
		
	</div>
</template>

<script>
import OpcionResumen from '../opciones/Opcion_Resumen';

export default {
	name: 'PedidoResumen',
	data: () => ({
		desactivado: false,
		permitirCancelarPedidoPendiente: false,
		pedidoPendiente: null,
		confirmarCancelarPedidoNoOrdenado: false,
		confirmarCancelarPedidoOrdenado: false,
		aModificar: false,
		aCancelar: false
	}),
	components: {
		OpcionResumen
	},
	props: ['pedido', 'elevation'],
	watch: {
		'pedido': {
			handler: function(v) {
				if (!v || (v && v.estado === 'NUEVO')) {
					clearTimeout(this.pedidoPendiente)
					this.desactivado = false
					this.permitirCancelarPedidoPendiente = false
					this.confirmarCancelarPedidoNoOrdenado = false
					this.confirmarCancelarPedidoOrdenado = false
					this.aModificar = false
					this.aCancelar = false
					return
				}
			},
			deep: true
		},
	},
	methods: {
		ordenar: function() {
			this.$set(this.pedido, 'estado', 'ORDENANDO')
			this.permitirCancelarPedidoPendiente = true
			this.confirmarCancelarPedidoNoOrdenado = false
			this.pedidoPendiente = setTimeout( () => {
				this.permitirCancelarPedidoPendiente = false
				this.$root.axios.post('/pedidos', this.pedido).then(rta => {
					this.$set(this.pedido, 'id', rta.data.id)
				}).catch(err => {
					this.$set(this.pedido, 'estado', 'NO_ORDENADO')
					alert(err.error || 'Ocurrió un error al ordenar el pedido. Intente de nuevo.')
				})
			}, 5000)
		},
		modificarNoOrdenado: function() {
			this.$emit('modificar', this.pedido)
		},
		modificarOrdenado: function() {
			this.aModificar = true
			this.$root.axios.patch(`/pedidos/${this.pedido.id}`, {modificando: true}).then(rta => {
				this.$emit('modificar', JSON.parse(JSON.stringify(Object.assign(this.pedido, {modificando: true}))))
				this.aModificar = false
			}).catch(err => {
				this.aModificar = false
				alert(err.error || 'Ocurrió un error al ordenar el pedido. Intente de nuevo.')
			})
		},
		cancelarPedidoPendiente: function() {
			clearTimeout(this.pedidoPendiente)
			this.permitirCancelarPedidoPendiente = false
			this.$set(this.pedido, 'estado', 'NO_ORDENADO')
		},
		cancelarPedidoNoOrdenado: function() {
			this.desactivado = true
			setTimeout( () => {
				this.$emit('cancelarPedidoNoOrdenado', true)
			}, 300)
		},
		cancelarPedidoOrdenado: function() {
			this.aCancelar = true
			this.confirmarCancelarPedidoOrdenado = false
			this.$root.axios.patch(`/pedidos/${this.pedido.id}`, {estado: 'CANCELADO'}).then(rta => {
				this.aCancelar = false
			}).catch(err => {
				this.aCancelar = false
				alert(err.error || 'Ocurrió un error al cancelar el pedido. Intente de nuevo.')
			})
		}
	}
}
</script>